import { render, staticRenderFns } from "./StoreForm.vue?vue&type=template&id=b9061b12&scoped=true&"
import script from "./StoreForm.vue?vue&type=script&lang=js&"
export * from "./StoreForm.vue?vue&type=script&lang=js&"
import style0 from "./StoreForm.vue?vue&type=style&index=0&id=b9061b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9061b12",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QField,QRadio,QInput,QSelect,QCard,QExpansionItem,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QField,QRadio,QInput,QSelect,QCard,QExpansionItem,QCardSection,QIcon})
